import { Locale } from "@linkfluence/models/locale";
import { tr } from "@radarly/i18n";
import { AgeClauseLabel } from "@radarly/models/clause/label";
import { LabelNode } from "./index";

export const getAgeLabelNode = (
  type: LabelNode,
  label: AgeClauseLabel,
  locale: Locale
) => {
  if (type === "minmax") return ageLabelMinMaxRange(locale);
  if (type === "from") return ageLabelFrom(label, locale);
  if (type === "to") return ageLabelTo(label, locale);
  return ageLabelDefault(label, locale);
};

const ageLabelMinMaxRange = (locale: Locale) => {
  return tr(locale, "FACETS::AGE::TITLE");
};

const ageLabelFrom = (label: AgeClauseLabel, locale: Locale) => {
  return tr(locale, "FACETS::AGE::INTERVAL_FROM", { from: label.gt });
};

const ageLabelTo = (label: AgeClauseLabel, locale: Locale) => {
  return tr(locale, "FACETS::AGE::INTERVAL_TO", {
    to: label.lowerBound ? label.lt + 1 : label.lt,
  });
};

const ageLabelDefault = (label: AgeClauseLabel, locale: Locale) => {
  return tr(locale, "FACETS::AGE::INTERVAL_FROM_TO", {
    from: label.gt,
    to: label.lt,
  });
};
